import PropTypes from 'prop-types';
import StudioImageTextSection from './StudioImageTextSection';

export default function StudioAboutSections({ sections = [] }) {
  if (!sections.length) return null;

  return (
    <>
      {sections.map(section => (
        <StudioImageTextSection
          key={section.id}
          id={section.id}
          eyebrow={section.eyebrow}
          title={section.title}
          body={section.body}
          imageSrc={section.imageSrc}
          imageAlt={section.imageAlt}
          imagePosition={section.imagePosition}
        />
      ))}
    </>
  );
}

StudioAboutSections.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      eyebrow: PropTypes.string,
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
      imageSrc: PropTypes.string,
      imageAlt: PropTypes.string,
      imagePosition: PropTypes.oneOf(['left', 'right']),
    }),
  ),
};
